
import React, { Fragment, useState } from 'react'
import DocumentIcon from '@material-ui/icons/InsertDriveFile'
import Delete from '@material-ui/icons/Delete'
import { css } from 'styled-components/macro'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next';
import { FlexContainer, Paragraph } from 'heliocor-ui'

import { WarningBox } from './WarningBox'
import { translateChecker } from '../utils/translateChecker'

const paragraphEllipsis = css`
    max-width: 16.5rem;      
    p {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }                             
`

const DeleteIcon =  styled(Delete)`&&{ 
    font-size: 1rem !important; 
    color: ${props => props.theme.colors.grey100}}; 
    cursor: pointer;
` 

const DocIcon = styled(DocumentIcon)`&&{ 
    font-size: 1rem !important; 
    color: ${props => props.theme.colors.grey100}}; 
` 

const DocumentsList = ({ data, keyToPrint, editable, handleDelete, docType, wrap, docId, canDelete=true }) => {

    const { t } = useTranslation()
    const [fileToDelete, setFileToDelete] = useState()
    const [modalIsOpen, openModal] = useState(false)

    const informDeletion = (doc) => {
        setFileToDelete(doc)
        openModal(true)
    }

    const docDeletion = (doc) => {
        handleDelete(doc)
        openModal(false)
    }

    const getDocName = (doc, index) => {
        const docName = translateChecker(doc[keyToPrint],null,'docs')
        const fallbackName = `${docType}_${index + 1}`
        return docName || fallbackName
    }

    if(!data) return null

    return(
        <Fragment>
            <FlexContainer flexWrap={wrap && 'wrap'}>
                {data.map((doc, index) => 
                    <FlexContainer 
                        key={index} 
                        margin='.25rem 0'
                        alignItems='center'
                        css={paragraphEllipsis}
                        data-cy={`summary-document-${doc?.type}`}
                        width='16.25rem'
                    >
                        <FlexContainer>
                            <DocIcon />
                            <Paragraph css='width:16rem; margin: 0; padding-left:1rem;'>
                                {getDocName(doc, index)}
                            </Paragraph>
                        </FlexContainer>
                        {(editable && canDelete) && (
                            <DeleteIcon onClick={() => informDeletion({index: doc.index, name: doc[keyToPrint]})} />
                        )}
                    </FlexContainer>    
                )}
            </FlexContainer>
            <WarningBox 
                content={ 
                    <Fragment>
                        {t('warning.deleteFile')}
                        <p css='text-align: center;'><i>{fileToDelete && fileToDelete.name}</i></p>
                    </Fragment>
                }
                onClose={() => openModal(false)}
                open={modalIsOpen}
                buttons={[
                    { type: 'default', onClick: () => docDeletion({docType, index: fileToDelete.index, identifier: docId}), value: t('button.continue'), autoFocus: true},
                    { type: 'light', margin: '0 1rem', onClick: () => openModal(false), value: t('button.cancel')}
                ]}
            />
        </Fragment>
    )
}

export { DocumentsList }